import ComponentManager from '../shared/component-manager';
import SortableTable from '../shared/components/sortable-table';
import TextEditorHelperForm from '../shared/components/text-editor-helper-form';

import AssetDropzone from './components/organizations/asset-dropzone';
import AssetModal from './components/organizations/asset-modal';
import AssetModalTrigger from './components/organizations/asset-modal-trigger';
import MentorList from './components/organizations/mentor-list';

class OrganizationComponentManager extends ComponentManager {
  initializeComponents() {
    AssetDropzone.initialize('.assetDropzone');
    MentorList.initialize('.userProfile-mentors');
    SortableTable.initialize('.sortableTable');
    TextEditorHelperForm.initialize('.form-control-froala');

    // There is only one .assetModal element in the DOM.
    // this is why we pass assetModal[0] to AssetModalTrigger.
    const assetModal = AssetModal.initialize('.assetModal');
    AssetModalTrigger.initialize('.assetModalTrigger', {
      assetModal: assetModal[0],
    });
  }
}

export const initialize = () => {
  jQuery(() => {
    new OrganizationComponentManager([
      AssetDropzone,
      AssetModalTrigger,
      SortableTable,
      TextEditorHelperForm,
    ]);
  });
};
